import { useScreenSize } from '../../hooks/useScreenSize';
import { Link, useLocation } from 'react-router-dom';
import SideBarMobile from './sideBarMobile';

export default function Sidebar() {
  const { isTablet } = useScreenSize();
    const location = useLocation();
  
    const isActive = (path: string): boolean => location.pathname === path;

  if (isTablet) {
    return <SideBarMobile />;
  }

  return (
    <div className="flex-colomn p-1">
      <h2 className="text-xl font-bold mb-6">Dashboard</h2>
      <nav className="navbar-sidebar flex-colomn align-center gap-2">
        <Link to="/dashboard" className={`navbar-sidebar-link ${isActive('/dashboard') ? 'navbar-sidebar-link--active' : ''}`}>
          overview
        </Link>
        {/* <Link to="/dashboard/gallery" className="navbar-sidebar-link">
          my gallery
        </Link> */}
        <Link to="/dashboard/support" className={`navbar-sidebar-link ${isActive('/dashboard/support') ? 'navbar-sidebar-link--active' : ''}`}>
          messages
        </Link>
        {/* <Link to="/dashboard/settings" className="navbar-sidebar-link">
          settings
        </Link> */}
      </nav>
    </div>
  );
}
